export const ClinicalApprovementOption = {
    1: 'option.approveiDesign2AndSmileDesign',
    2: 'option.approveSmileDesign',
    APPROVE_IDESIGN_ALIGNER: 'option.approveiDesign2',
};
